import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const testsRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/getalltests`;
const deleteRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/deletetest`;
const visibilityRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/update-visibility`;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then(response => response.json())
    .then(json => json)
    .catch((error) => { throw error })
}

function testRequestApi ({ filters }) {
  const url = new URL(testsRequestUrl);
  url.search = new URLSearchParams(filters);
  const request = fetch(url, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* testRequestFlow (action) {
  try {
    const result = yield call(testRequestApi, action)
    yield put(Actions.testSuccess(result))
  } catch (error) {
    yield put(Actions.testError(error))
  }
}

function deleteRequestApi ({ id }) {
  const request = fetch(deleteRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ test_id: id }),
  })

  return handleRequest(request)
}
function* deleteRequestFlow (action) {
  try {
    const result = yield call(deleteRequestApi, action)
    yield put(Actions.deleteSuccess(result))
    yield testRequestFlow(action)
  } catch (error) {
    yield put(Actions.deleteError(error))
  }
}

function visibilityRequestApi ({ id, visibility }) {
  const request = fetch(visibilityRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ test_id: id, is_published: visibility }),
  })

  return handleRequest(request)
}
function* visibilityRequestFlow (action) {
  try {
    const result = yield call(visibilityRequestApi, action)
    yield put(Actions.visibilitySuccess(result))
    yield testRequestFlow(action)
  } catch (error) {
    yield put(Actions.visibilityError(error))
  }
}

function* testWatcher () {
  yield all([
    takeLatest(Constants.TEST_REQUEST, testRequestFlow),
    takeLatest(Constants.DELETE_REQUEST, deleteRequestFlow),
    takeLatest(Constants.VISIBILITY_REQUEST, visibilityRequestFlow),
  ]);
}

export default testWatcher
